import { sidebarMenus } from '../components/layout/sidebar.description'
import PageNotFound from '../components/PageNotFound'
import useRouter from '../hooks/useRouter'
import { USER_TXT } from '../routing/pathName.constant'
import { getUserData } from '../utils'
import { include, isEqual, ternary } from '../utils/javascript'

const withUserRoute = Component => {
  return props => {
    const { location } = useRouter()
    const { userData } = getUserData()
    const { roleId } = { ...userData }
    const isValid = sidebarMenus
      .find(({ key }) => isEqual(key, USER_TXT))
      .children.some(menu => {
        if (isEqual(menu.key, location.pathname)) {
          return include(menu?.sidebar, roleId)
        }
        return null
      })

    return <>{ternary(isValid, <Component {...props} />, <PageNotFound />)}</>
  }
}

export default withUserRoute
